import React from 'react';
import { useToast } from '@common/toast';
import { copyUrl, shareLinkWithFacebook, shareLinkWithKakao } from '@utils/common';

import classnames from 'classnames/bind';
import styles from './share.module.scss';
const cx = classnames.bind(styles);

interface ShareProps {
  positionSn?: number;
}

const Share = ({ positionSn }: ShareProps) => {
  const Toast = useToast();

  const handleShareKakao = () => {
    if (!positionSn) return;

    shareLinkWithKakao({
      title: '[잡다] 포지션(공고)을 확인해보세요!',
      description: '잡다에서 포지션 확인하고 지원까지 해보세요!',
      btnText: '자세히 보기',
      imageUrl: 'https://www.jobda.im/img/v2/components/share/imgSharePosition.png',
      mobileWebUrl: `https://m.jobda.im/position/${positionSn}/jd`,
      webUrl: `https://www.jobda.im/position/${positionSn}/jd`,
    });
  };

  const handleShareFacebook = () => {
    if (!positionSn) return;

    shareLinkWithFacebook();
  };

  const handleCopy = () => {
    if (!positionSn) return;

    copyUrl(() =>
      Toast({
        iconType: 'info',
        content: 'URL을 복사했습니다.',
      }),
    );
  };

  return (
    <div className={cx('shareArea')}>
      <a className={cx('btnShare', 'kakao')} role="button" onClick={handleShareKakao}>
        <span className={cx('hidden')}>share kakao</span>
      </a>
      <a className={cx('btnShare', 'facebook')} role="button" onClick={handleShareFacebook}>
        <span className={cx('hidden')}>share facebook</span>
      </a>
      <a className={cx('btnShare', 'url')} role="button" onClick={handleCopy}>
        <span className={cx('hidden')}>share url</span>
      </a>
    </div>
  );
};

export default Share;
